import { render } from "./AccordianComp.vue?vue&type=template&id=09fd9ef4"
import script from "./AccordianComp.vue?vue&type=script&lang=js"
export * from "./AccordianComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__